import React from 'react'

const SlideFour = () => (
  <div className="slide">
    <div className="slide-inner">
      <div className="slide-left">
        <h2>The ZERO Advantage</h2>
        <p>
          Advantages of using the Avalanche Blockchain to underpin ZERO Exchange
        </p>
      </div>
      <div className="slide-right">
        <img src="/zero-advantage.png" alt="Zeronomics" />
      </div>
    </div>
  </div>
)

export default SlideFour
